export const properties = [
  {
    id: 1,
  slug: "modern-downtown-apartment-delhi",
  complete: true,
    title: "Modern Downtown Apartment",
    price: "₹45,00,000",
    location: "Connaught Place, Delhi",
    bedrooms: 3,
    bathrooms: 3,
    area: "1,200 sq ft",
    type: "apartment",
    image: "https://fiverr-res.cloudinary.com/images/t_main1,q_auto,f_auto,q_auto,f_auto/gigs/202676081/original/bbe950c0dffc308209418cb105cd63c6c4dc2107/do-3d-visualization-of-interior-and-exterior.jpg?height=300&width=400&text=Downtown+Apartment",
    featured: true,
    images: [
      "https://fiverr-res.cloudinary.com/images/t_main1,q_auto,f_auto,q_auto,f_auto/gigs/202676081/original/bbe950c0dffc308209418cb105cd63c6c4dc2107/do-3d-visualization-of-interior-and-exterior.jpg?height=400&width=600&text=Modern+Apartment+1",
      "https://img.peerspace.com/image/upload/c_crop,g_custom/g_auto,c_fill,q_auto,f_auto,fl_progressive:steep,w_800,ar_1.6/tafxb0ehncr7ugzknbsm?w=626&h=626&rs=1&pid=ImgDetMain&o=7&rm=3?height=400&width=600&text=Modern+Apartment+2",
      "https://www.souciehorner.com/wp-content/uploads/2017/04/Kitchen3-1536.jpg?height=400&width=600&text=Modern+Apartment+3",
      "https://img.peerspace.com/image/upload/f_auto,q_auto,dpr_auto,w_3840/psmmridxsg17vezlwpib?height=400&width=600&text=Modern+Apartment+4"
    ],
    description: "A stunning modern apartment in the heart of Delhi's business district. This beautifully designed 2-bedroom unit features contemporary finishes, floor-to-ceiling windows, and premium amenities. Perfect for professionals and small families looking for urban convenience.",
    amenities: ["WiFi", "Parking", "Security", "Garden", "Power Backup"],
    features: [
      "Prime location in Connaught Place",
      "24/7 security and concierge",
      "Modern kitchen with premium appliances",
      "Master bedroom with en-suite bathroom",
      "Balcony with city views",
      "Central air conditioning",
      "Covered parking space",
      "Access to rooftop garden"
    ],
    nearbyPlaces: [
      { name: "Metro Station", distance: "200m" },
      { name: "Shopping Mall", distance: "500m" },
      { name: "Hospital", distance: "1.2km" },
      { name: "School", distance: "800m" }
    ],
    agent: {
      name: "Walter White",
      phone: "+91 99XXXXXXXX",
      email: "walter@makaanwala.com",
      image: "https://vignette.wikia.nocookie.net/breakingbad/images/4/46/Cast_bb_800x600_walter-white.jpg/revision/latest/scale-to-width-down/350?cb=20170613183854"
    }
    ,
    model: {
      type: 'gltf',
      path: '/models/apartments/scene.gltf',
      targetSize: 16
    }
  },
  {
    id: 2,
  slug: "luxury-villa-pool-bandra-mumbai",
  complete: true,
    title: "Luxury Villa with Pool",
    price: "₹1,20,00,000",
    location: "Bandra West, Mumbai",
    bedrooms: 4,
    bathrooms: 3,
    area: "3,500 sq ft",
    type: "villa",
    image: "https://villascroatia.com/wp-content/uploads/2020/08/modern-luxury-villa-pool-medulin-croatia-01-2.jpg?height=300&width=400&text=Luxury+Villa",
    featured: true,
    images: [
      "https://villascroatia.com/wp-content/uploads/2020/08/modern-luxury-villa-pool-medulin-croatia-01-2.jpg?height=400&width=600&text=Luxury+Villa+1",
      "https://villascroatia.com/wp-content/uploads/2020/08/modern-luxury-villa-pool-medulin-croatia-13-1.jpg?height=400&width=600&text=Luxury+Villa+2",
      "https://villascroatia.com/wp-content/uploads/2020/08/modern-luxury-villa-pool-medulin-croatia-12-1.jpg?height=400&width=600&text=Luxury+Villa+3",
      "https://villascroatia.com/wp-content/uploads/2020/08/modern-luxury-villa-pool-medulin-croatia-02.jpg?height=400&width=600&text=Luxury+Villa+4"
    ],
    description: "An exquisite luxury villa offering the perfect blend of comfort and elegance. Located in prestigious Bandra West, this property features a private swimming pool, landscaped gardens, and top-of-the-line amenities throughout.",
    amenities: ["WiFi", "Parking", "Security", "Garden", "Power Backup", "Swimming Pool"],
    features: [
      "Private swimming pool and deck",
      "Landscaped garden with outdoor seating",
      "Spacious living areas with high ceilings",
      "Gourmet kitchen with island",
      "Master suite with walk-in closet",
      "3 additional bedrooms with attached baths",
      "2-car garage with storage",
      "Home office/study room"
    ],
    nearbyPlaces: [
      { name: "Bandra Station", distance: "1.5km" },
      { name: "Linking Road", distance: "1km" },
      { name: "Lilavati Hospital", distance: "2km" },
      { name: "American School", distance: "1.8km" }
    ],
    agent: {
      name: "Skyler White",
      phone: "+91 99XXXXXXXX",
      email: "skyler@makaanwala.com",
      image: "https://dygtyjqp7pi0m.cloudfront.net/i/21084/22735773_3.jpg?v=8D28033E5EA82A0"
    }
    ,
    model: {
      type: 'fbx',
      path: '/models/modern-luxury-villa-house-building-with-pool/source/42.fbx',
      targetSize: 22
    }
  },
  {
    id: 3,
  slug: "commercial-office-space-cyber-city-gurgaon",
  complete: true,
    title: "Commercial Office Space",
    price: "₹80,00,000",
    location: "Cyber City, Gurgaon",
    bedrooms: 0,
    bathrooms: 12,
    area: "2,000 sq ft",
    type: "commercial",
    image: "https://i.pinimg.com/originals/00/09/9e/00099e7e6776dbd8d137cc5c39905fda.jpg?height=300&width=400&text=Office+Space",
    featured: false,
    images: [
      "https://i.pinimg.com/originals/00/09/9e/00099e7e6776dbd8d137cc5c39905fda.jpg?height=400&width=600&text=Office+Space+1",
      "https://thearchitectsdiary.com/wp-content/uploads/2023/11/Interior-design-3-1024x574.webp?height=400&width=600&text=Office+Space+2",
      "https://arktura.com/wp-content/uploads/2017/01/Arktura-SoundAngle-Confidential_WEB_1-1600x1078.jpg?height=400&width=600&text=Office+Space+3",
      "https://drk-realty.com/images/AdobeStock_329295634.jpeg?height=400&width=600&text=Office+Space+4"
    ],
    description: "Premium commercial office space in the heart of Cyber City, Gurgaon. This modern workspace offers excellent connectivity, state-of-the-art infrastructure, and a professional environment perfect for growing businesses.",
    amenities: ["WiFi", "Parking", "Security", "Power Backup", "Conference Room"],
    features: [
      "Grade A office building",
      "24/7 security and access control",
      "High-speed elevators",
      "Central air conditioning",
      "Dedicated parking spaces",
      "Conference room access",
      "Cafeteria and food court",
      "Metro connectivity"
    ],
    nearbyPlaces: [
      { name: "Cyber Hub", distance: "500m" },
      { name: "Metro Station", distance: "300m" },
      { name: "Hospital", distance: "2km" },
      { name: "Shopping Complex", distance: "1km" }
    ],
    agent: {
      name: "Jesse Pinkman",
      phone: "+91 99XXXXXXXX",
      email: "jesse@makaanwala.com",
      image: "https://tse2.mm.bing.net/th/id/OIP.bMMCqogxWFqrqrJUf2LvZQHaHU?pid=ImgDet&w=198&h=196&c=7&o=7&rm=3"
    }
    ,
    model: {
      type: 'gltf',
      path: '/models/modern_office_building/scene.gltf',
      targetSize: 24
    }
  },
  {
    id: 4,
  slug: "cozy-studio-apartment-koramangala-bangalore",
  complete: false,
    title: "Cozy Studio Apartment",
    price: "₹28,00,000",
    location: "Koramangala, Bangalore",
    bedrooms: 1,
    bathrooms: 1,
    area: "600 sq ft",
    type: "apartment",
    image: "https://adorable-home.com/wp-content/uploads/2018/08/Cozy-Studio-1.jpg?height=300&width=400&text=Studio+Apartment",
    featured: false,
    images: ["/placeholder.svg?height=400&width=600&text=Studio+1"],
    description: "Compact and efficient studio in Bangalore's vibrant Koramangala area. Ideal for singles or students.",
    amenities: ["WiFi", "Security", "Power Backup"],
    features: ["Natural light", "Modern bathroom", "Secure building"],
    nearbyPlaces: [
      { name: "Tech Park", distance: "2km" },
      { name: "Cafe Strip", distance: "300m" }
    ],
    agent: { name: "Generic Agent", phone: "+91 98XXXXXXXX", email: "agent@makaanwala.com", image: "https://placehold.co/80x80" }
    ,
    model: {
      type: 'procedural',
      targetSize: 14
    }
  },
  {
    id: 5,
  slug: "family-villa-garden-jubilee-hills-hyderabad",
  complete: false,
    title: "Family Villa with Garden",
    price: "₹95,00,000",
    location: "Jubilee Hills, Hyderabad",
    bedrooms: 5,
    bathrooms: 4,
    area: "4,200 sq ft",
    type: "villa",
    image: "https://www.serenevilla.com/gallery/sgv-gal-garden5.jpg?height=300&width=400&text=Family+Villa",
    featured: true,
  images: ["/placeholder.svg?height=400&width=600&text=Family+Villa+1"],
  description: "Spacious family villa with lush garden ideal for large families.",
  amenities: ["Parking", "Garden", "Power Backup"],
  features: ["Large plot", "Outdoor seating", "Multiple storage rooms"],
  nearbyPlaces: [{ name: "School", distance: "1km" }],
  agent: { name: "Family Specialist", phone: "+91 97XXXXXXXX", email: "villa@makaanwala.com", image: "https://placehold.co/80x80" }
  ,
  model: {
    type: 'procedural',
    targetSize: 18
  }
  },
  {
    id: 6,
  slug: "retail-space-downtown-commercial-street-bangalore",
  complete: false,
    title: "Retail Space Downtown",
    price: "₹60,00,000",
    location: "Commercial Street, Bangalore",
    bedrooms: 0,
    bathrooms: 1,
    area: "1,500 sq ft",
    type: "commercial",
    image: "https://images.squarespace-cdn.com/content/v1/5bff145a5417fce9c4839dcb/1544030196324-RYRVN11A94IN001RB2Q7/MCC_Building+(1+of+30).jpg?height=300&width=400&text=Retail+Space",
    featured: false,
  images: ["/placeholder.svg?height=400&width=600&text=Retail+1"],
  description: "High visibility retail space perfect for boutique or service business.",
  amenities: ["Parking", "Security", "Power Backup"],
  features: ["Street frontage", "Signage opportunity"],
  nearbyPlaces: [{ name: "Main Market", distance: "100m" }],
  agent: { name: "Retail Broker", phone: "+91 96XXXXXXXX", email: "retail@makaanwala.com", image: "https://placehold.co/80x80" }
  ,
  model: {
    type: 'procedural',
    targetSize: 16
  }
  },
];

// Helper utilities for consistent data access
export const getPropertyById = (id) => properties.find(p => p.id === Number(id));
export const getPropertyBySlug = (slug) => properties.find(p => p.slug === slug);
export const searchProperties = (q) => {
  if (!q) return [];
  const query = q.toLowerCase();
  return properties.filter(p =>
    p.title.toLowerCase().includes(query) ||
    p.location.toLowerCase().includes(query) ||
    p.type.toLowerCase().includes(query) ||
    (p.description && p.description.toLowerCase().includes(query))
  );
};

export default properties;
